import get from './http/get.js';

const loadConfig = async () =>
  await(await get('/api/config')).json();

export default loadConfig;